import React from 'react';
import PropTypes from 'prop-types';
import CaseActivityDocketsRow from './rows/CaseActivityDocketsRow';
import CaseActivityClaimsRow from './rows/CaseActivityClaimsRow';
import DocketPopup from '../../case/docket/popups/DocketPopup';
import ResultsPaginator from './ResultsPaginator';

const CaseActivityResults = ({ data, filter, onSearch }) => (
  <div id="ir-search-search-premium-results">
    <h2>
      Results – {data.num_found} matches within {data.num_cases} cases
    </h2>
    {data.results.map((row, idx) => {
      const type = row.query || row.document_type.replace('_part', '');
      const case_url = `/rpc/legacy/case-menu-redirect/${row.case_court}/${row.case_no}`;

      return (
        <div key={idx} className={`result-item result-item-${type}`}>
          <h3 className="result-item-header">
            {row.case_title}
            {' | '}
            <a href={case_url} title="Go to Case Query Menu" target="_blank">
              {row.case_no}
            </a>
            {' | '}
            Entries: {row.dockets.length + row.claims.length}
          </h3>
          <div className="result-item-body">
            {row.dockets && row.dockets.length > 0 && (
              <table className="ir-search-table-results sticky-enabled docket">
                <thead>
                  <tr>
                    <th>Date Filed</th>
                    <th>#</th>
                    <th>Docket Text</th>
                  </tr>
                </thead>
                {row.dockets.map((docket, idx) => (
                  <CaseActivityDocketsRow row={docket} id={idx} key={idx} />
                ))}
              </table>
            )}
            {/*TODO: Update claims rows when we'll have them reactified*/}
            {row.claims && row.claims.length > 0 && (
              <table className="ir-search-table-results sticky-enabled docket">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Original Filed Date</th>
                    <th>Creditor</th>
                    <th>Total Claimed Amount</th>
                    <th>Last Updated</th>
                  </tr>
                </thead>
                {row.claims.map((claim, idx) => (
                  <CaseActivityClaimsRow row={claim} key={idx} />
                ))}
              </table>
            )}
          </div>
        </div>
      );
    })}
    <ResultsPaginator
      totalPages={data.page_count}
      selectedPage={filter.page + 1 || 1}
      onChangePage={page => onSearch({ ...filter, page })}
    />
    <div className="docket">
      <DocketPopup />
    </div>
  </div>
);

CaseActivityResults.propTypes = {
  data: PropTypes.any.isRequired,
};

export default CaseActivityResults;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/CaseActivityResults.jsx